import { t } from '@lingui/core/macro';
import * as React from 'react';
import { user } from 'utils/auth/user';

/** Read-only replacement for the removed dealer-switching popover (AVS-4405, AC6). */
export default function ActiveDealerId() {
  const dealerId = user.dealerId;

  if (!dealerId) {
    return null;
  }

  return (
    <span
      className="inline-flex items-center gap-x-1 text-sm/10 font-semibold"
      part="active-dealer-id"
      data-testid="active-dealer-id"
      aria-label={t`Dealer ID ${dealerId}`}
    >
      <span className="ex3d-button-text">{dealerId}</span>
    </span>
  );
}
